import { Directive, HostListener, ElementRef } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appNumber]'
})
export class NumberDirective {

  constructor(private control: NgControl, private el: ElementRef) { }

  @HostListener('input', ['$event']) onChange() {
    const controlName = this.control.control;
    const value = this.el.nativeElement.value;
    if (value) {
      const process = value.replace(/[^0-9]*/g, '');
      if (value && value !== process) {
        controlName.setValue(process);
      }
    }
  }

  @HostListener('compositionend', ['$event']) onCompositionend() {
    const controlName = this.control.control;
    const value = this.el.nativeElement.value;
    if (value) {
      const process = value.replace(/[^0-9]*/g, '');
      if (value && value !== process) {
        controlName.setValue(process);
      }
    }
  }

}
